import { getPermittedActions } from '../models/permittedActions';
import { actionsList } from '../models/actions';

function Permission({ action, alternate, children }) {
    if (!actionsList.includes(action)) {
        throw new Error('Invalid action passed as argument');
    }
    if (getPermittedActions().includes(action)) {
        return children;
    } else {
        return alternate ? alternate : null;
    }
}

export default Permission;
